import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { TestAssetListPageFilterSchema } from './-zod-schema';

export const Route = createFileRoute('/_stacktrace/test-assets/')({
  validateSearch: zodValidator(TestAssetListPageFilterSchema),
});
